import { computed } from 'vue';
import {
  createAdsAcc,
  fetchAdsAccs,
  updateAdsAcc,
  deleteAdsAcc,
} from 'api/adsAccs';
import { Resource, computedMapById } from './store';

export default Resource.build(({ state }) => {
  return {
    name: 'AdsAccs',
    state,

    values: {
      byId: computedMapById(state),
      byGroup: computed(() =>
        state.data?.reduce((acc, adsAcc) => {
          const { group } = adsAcc;
          (acc[group] = acc[group] || []).push(adsAcc);
          return acc;
        }, {}) || {},
      ),
    },

    actReqs: {
      add: createAdsAcc,
      fetch: fetchAdsAccs,
      update: updateAdsAcc,
      delete: deleteAdsAcc,
    },
  };
});
